import { z } from 'zod';
import { IsoDateTime, TimeZone, Uuid } from './common.js';
/**
 * Module `onboarding` (docs/modules/onboarding.md, spec 8.6.1 "tenant onboarding wizard"). Owner: S53.
 * First site, groups from a template (Visitors, Staff, Contractors), first kiosk pairing, branding and first users.
 */
export const OnboardingStepKey = z.enum(['branding', 'site', 'groups', 'kiosk', 'users']);
export const OnboardingState = z.object({
    steps: z.array(z.object({ key: OnboardingStepKey, status: z.enum(['todo', 'done', 'skipped']) })),
    /** Set when every step is done or skipped, or the admin dismisses the wizard. */
    completedAt: IsoDateTime.nullable(),
    /** The site created by the wizard (later steps use it). */
    siteId: Uuid.nullable(),
});
export const OnboardingSiteInput = z.object({
    name: z.string().trim().min(1).max(120),
    address: z.string().trim().max(500).default(''),
    timeZone: TimeZone.default('Europe/London'),
});
export const GroupTemplateKey = z.enum(['visitors', 'staff', 'contractors']);
export const OnboardingGroupsInput = z.object({ templates: z.array(GroupTemplateKey).min(1).max(3) });
export const OnboardingGroupsResult = z.object({ groups: z.array(z.object({ template: GroupTemplateKey, groupId: Uuid, created: z.boolean() })) });
export const OnboardingStepUpdate = z.object({ status: z.enum(['done', 'skipped']) });
export const OnboardingTenantSettings = z.object({
    /** Show the wizard on the home page until it is completed or dismissed. */
    showWizard: z.boolean().default(true),
});
//# sourceMappingURL=onboarding.js.map